<template>
  <v-container>
    <v-card>
      <v-toolbar flat color="white">
        <template v-slot:extension class="mt-n12">
          <v-tabs v-model="tab" fixed-tabs icons-and-text>
            <v-tabs-slider></v-tabs-slider>
            <v-tab href="#dashboard" class="primary--text">
              <v-icon size="25">mdi-information</v-icon>
              <span>PROMOCIONES</span>
            </v-tab>
            <v-tab href="#addPromo" class="primary--text">
              <v-icon>mdi-plus</v-icon>
              <span>Agregar promocion</span>
            </v-tab>
          </v-tabs>
        </template>
      </v-toolbar>

      <v-tabs-items v-model="tab">
        <v-tab-item :value="'dashboard'">
          <dashboard-promos></dashboard-promos>
        </v-tab-item>
        <v-tab-item :value="'addPromo'">
          <v-container>
            <add-promo></add-promo>
          </v-container>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>
<script>
import moment from "moment";
import _ from "lodash";

import axios from "axios";
import AddPromo from "./addPromo.vue";
export default {
  components: {
    DashboardPromos: () => import("./dashboard"),
    AddPromo: () => import("./addPromo"),
  },
  data: () => ({
    tab: null,
  }),
};
</script>



